import { render, staticRenderFns } from "./onelineExamDetail.vue?vue&type=template&id=230b208f"
import script from "./onelineExamDetail.vue?vue&type=script&lang=js"
export * from "./onelineExamDetail.vue?vue&type=script&lang=js"
import style0 from "./onelineExamDetail.vue?vue&type=style&index=0&id=230b208f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports